import React, { useCallback, useEffect, useState } from 'react';
import TableContainer from 'components/TableContainer';
import _ from "lodash";
import { CellRenderers, getFilterProps, Sorters } from "utils/tableUtils";
import Vocabulary from 'components/Vocabulary';
import ModalUtil from 'utils/modalUtil';
import message from 'components/CustomMessage';
import { ToolNotificationPopup } from './ToolNotification';
import ActionMenuV2 from 'components/ActionMenuV2';
import AlertsAPI from 'restAPI/AlertsAPI';
import { Button, Typography } from 'antd';
import { PermissionSetMap } from 'constants/RBACConstants';
import AuthorisedContainer from 'components/AuthorisedContainer';
import TrimText from 'views/Findings/TrimText';
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';

const ToolNotificationsListing = ({name}) => {
    const [data, setData] = useState(null);
    const globalFilter = useGlobalFilterContext();

    const fetchData = useCallback(async () => {
        setData(null);
        const data = await AlertsAPI.getAlertNotification(name).promise;
        setData(data.content);
    }, [name, globalFilter.globalFilterHash]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetchData();
    }, [fetchData])

    const showToolNotificationPopup = (data) => {
        ModalUtil.show({
            content: <ToolNotificationPopup name={name} notificationData={data} updateData={fetchData} />
        })
    }

    const onDelete = (id) => {
        const { promise } = AlertsAPI.deleteAlertNotification(id)
        promise.then(() => {
        message.success('Configuration deleted successfully.');
        fetchData();
        })
        return promise
    }

    const onActionClick = (name, record) => {
        switch(record.name) {
            case "edit":
                showToolNotificationPopup(record.data)
                break;
            case "delete":
                onDelete(record.data?.id)
                break;
            default:
                break;
        }
    }

    const columns = [{
        title: "Title",
        dataIndex: "title",
        sorter: Sorters.STRING('title'),
        render: (title) => title ? <TrimText content={title} length={50} /> : 'N/A'
    }, {
        title: "Description",
        dataIndex: "description",
        render: (desc) => desc ? <TrimText content={desc} length={50} /> : 'N/A'
    }, {
        title: <Vocabulary name="severity" />,
        dataIndex: "severity",
        render: CellRenderers.SEVERITY,
        sorter: Sorters.SEVERITY('severity'),
    }, {
        title: <Vocabulary name="product" />,
        dataIndex: "productName",
        render: (value) => value || "All",
        sorter: Sorters.STRING('productName'),
        ...(getFilterProps({ dataIndex: "productName", dataSource: data})),
    }, {
        title: <Vocabulary name="subProduct" />,
        dataIndex: "subProductName",
        render: (value) => value || "All",
        sorter: Sorters.STRING('subProductName'),
        ...(getFilterProps({ dataIndex: "subProductName", dataSource: data})),
    }, {
        title: "Environment",
        dataIndex: "environmentName",
        render: (value) => value || "All",
        sorter: Sorters.STRING('environmentName'),
        ...(getFilterProps({ dataIndex: "environmentName", dataSource: data})),
    }, {
        title: "Action",
        dataIndex: "id",
        width: 80,
        render: (id, record) => <ActionMenuV2 items={actionItems} onClick={onActionClick} data={record} />
    }]

    return (
        <>
            <div className='d-flex justify-content-between align-items-center m-y-sm'>
                <Typography.Text style={{width: 616}}>
                    Set the custom notifications when operations status is down, no new report found, config changed, tool configuration gets disabled. Additionally Severity, notify to, create ticket con be configured.
                </Typography.Text>
                <AuthorisedContainer permission={PermissionSetMap.CREATE_SLA}><Button onClick={() => showToolNotificationPopup()} type="primary" size="small" className="text-right" >Create</Button></AuthorisedContainer>
            </div>
            <TableContainer
                enableScroll={true}
                loading={_.isNull(data)}
                columns={columns}
                dataSource={data}
                rowKey="id"
                showSizeChanger={true}
            />
        </>
    )
}

export default ToolNotificationsListing;

const actionItems = [{
    type: "edit"
}, {
    type: "delete",
    permission: PermissionSetMap.DELETE_SLA
}]
